import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MealDietCard } from '../../ng-for-business.models';
import { OrangeButtonComponent } from '../../../../layout/components/orange-button/orange-button.component';

@Component({
  selector: 'app-ng-business-meal-diet',
  standalone: true,
  imports: [CommonModule, OrangeButtonComponent],
  templateUrl: './meal-diet.component.html',
  styleUrls: ['./meal-diet.component.scss'],
})
export class MealDietComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
  @Input({ required: true }) cards!: MealDietCard[];
  @Input({ required: true }) note!: string;
  @Input({ required: true }) ctaText!: string;


  trackByMeal = (_: number, meal: MealDietCard) => meal.title;


  scrollToElement(elementId: string) {
  const element = document.getElementById(elementId);
  if (element) {
    const offset = 100;
    const elementPosition = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: elementPosition, behavior: 'smooth' });
  }
}


}
